import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	remainingTimeEstimate: {
		id: 'backlog.card-list.work-load-by-assignee.tooltip-content.remaining-time-estimate',
		defaultMessage: '{remainingTimeEstimate} remaining time estimate',
		description: 'Remaining time estimate assigned to an assignee in a sprint',
	},
	issueCount: {
		id: 'backlog.card-list.work-load-by-assignee.tooltip-content.issue-count',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}}',
		description: 'Issue count assigned to an assignee in a sprint',
	},
	issueCountIssueTermRefresh: {
		id: 'backlog.card-list.work-load-by-assignee.tooltip-content.issue-count-issue-term-refresh',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}}',
		description: 'Issue count assigned to an assignee in a sprint',
	},
});
